import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import React from 'react';
import PropTypes from 'prop-types';

export default function CorporationUsageResource({ resourceList, rootCorporationInfo , listProvideFunction}) {
    if (Utils.isEmptyArray(resourceList)) return null;
    
    const isNotShowValue = label => {
        let isDeskServiceOn =
            rootCorporationInfo?.limitValue?.deskService === Constant.STATUS_SERVICE_PERMISSION.ON;
        let isKnowledgeServiceOn =
            rootCorporationInfo?.limitValue?.knowledgeService ===
            Constant.STATUS_SERVICE_PERMISSION.ON;
        let isShow = false;

        switch (label) {
            case Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_B2C_ID_NUMBER:
            case Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_SUPPORT_COUNTER_NUMBER:
            case Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_PUBLIC_DESK_NUMBER:
                isShow = isDeskServiceOn;
                break;
            case Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_KNOWLEDGE_TICKET_NUMBER:
                isShow = isKnowledgeServiceOn;
                break;
            case Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_EXTERNAL_WEB_API_CALLS_NUMBER: {
                // comment for now
                // out of scope. it will be used in next sprints.
                // const settingExternalAPI = listProvideFunction?.find(
                //     item => item.label === Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_EXTERNAL_WEB_API
                // );
                // const isOnExternalAPI = !!settingExternalAPI?.switchCorporation;
                break;
            }
            default:
                isShow = true;
        }
        return isShow;
    };

    return (
        <>
            {resourceList?.map((resource, index) => {
                return (
                    <> {
                        (isNotShowValue(resource.label)) && (
                            <div className="setting-item setting-item-group border-bottom">
                                <div className="title-parent-tree">
                                    <label className={`${resource.isOverMax && 'text-over-max-warning'} setting-label-tree`}>{I18n.get(resource.label)}</label>
                                    <div className={`${resource.isOverMax && 'text-over-max-warning'}`}>
                                        {resource.value}{' '}
                                        {resource?.maxValue !== undefined && <span>/</span>}{' '}
                                        {resource.maxValue} {resource?.unit}
                                    </div>
                                </div>
                                {!Utils.isEmptyArray(resource.listItems) &&
                                    resource.listItems?.map(itemChild => {
                                        return (
                                            isNotShowValue(itemChild.label) ? <></> : 
                                            <div className="setting-children-item">
                                                <label className="setting-label">
                                                    {I18n.get(itemChild.label)}
                                                </label>
                                                <div className="switch-check">
                                                    {itemChild?.value} {itemChild?.unit}
                                                </div>
                                            </div>    
                                        );
                                    })}
                            </div>
                        )
                    }
                    </>
                );
            })}
        </>
    );
}

CorporationUsageResource.propTypes = {
    resourceList: PropTypes.any,
    rootCorporationInfo: PropTypes.any,
    listProvideFunction: PropTypes.any
};